import numeral from 'numeral';

export const formatNumber = (value: number, formatString: string) => {
  const valWithMin = +value >= 1e-6 ? +value : 0;
  const result = numeral(valWithMin.toFixed(8)).format(formatString);
  return result;
};

export function formatChainSymbol(chain: string) {
  const filtered = chain?.replace?.(/gyri/i, 'Gala Chain');
  return filtered?.replace?.(/gyri/i, filtered) ?? '';
}
